<template>

    <div id="app" :style="cssVars" class="d-flex flex-column min-vh-100">

      <div v-if="isBeta"  class="beta-banner">
        🔧 This is a beta version. Some functionality may be incomplete or unstable. For the stable release, click 
        <a href="https://biotxplorer.sibils.org" target="_blank" rel="noopener">here</a>.
      </div>

      <div class="survey-banner" :style="{ top: isBeta ? '40px' : '0' }">
        📢 Your feedback makes a difference! Help us improve our search by taking this brief survey (less than 5 minutes):
        <a href="https://heg.qualtrics.com/jfe/form/SV_3qs9t6vdbawILl4" target="_blank" rel="noopener">click here</a>.
      </div>

      <div :class="isBeta ? 'with-beta-banner' : 'with-survey-banner'">

        <div id="nav">
            <router-link to="/">Search</router-link> |
            <router-link to="/collections">Collections</router-link> |
            <a :href="apiLink">API</a> |
            <router-link to="/about">About</router-link> |
            <router-link to="/privacy">Privacy</router-link>
        </div>

        <router-view/>

        <div class="logo row mt-auto">
          <div class="col-1">
                  <img src="./assets/images/logo_ebiodiv.png"/>
            </div>
              <div class="col-1">
                  <img src="./assets/images/logo_gbif.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_plazi.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_tb.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_bicikl.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_unibern.png"/>   
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_nmbe.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_swissuni.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_sib.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_heg.png"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_hesso.jpg"/>
            </div>
            <div class="col-1">
                  <img src="./assets/images/logo_sibils.png"/>
            </div>
        </div>
      </div>

    </div>

</template>

<script>
import { mapState } from 'vuex'

    export default {
      computed: {
            ...mapState(['theme_color', 'urls']),
            cssVars () {
                return{
                    '--color-main': this.theme_color.main,
                }
            },
            isBeta () {
              if (process.env.NODE_ENV != 'production'){
                return true
              }
              else {
                return false
              }
              
            },
            apiLink(){
              var url = this.urls.gui
              if (process.env.NODE_ENV != 'production'){
                  url = window.location.origin
              }
              url += "/api/"
              return url
            }
      },
      created() {
        this.$router.beforeEach((to, from, next) => {
          this.updatePageTitle(to.meta.title);
          next();
        });
      },
      methods:{
        updatePageTitle(){
          window.document.title = "BiotXplorer"
        }

      },
      mounted() { 
      },
    }

</script>


<style lang="scss">

   #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      font-size: 0.8em;

      .banner-container {
        width: 99%;
        margin: 0 auto;
      }

      .component-container {
        width: 100%;
        margin: 0 auto;
      }

      .query-container {
        padding: 20px;
        background-color: #F2F2F2;
        border-radius: 10px;
      }

      a {
        font-weight: bold;
        text-decoration: none;
        color: var(--color-main);
      }
      a:hover {
        text-decoration: underline;
      }

      h1 {
        font-size: 1.8em;
        padding: 20px 0;
        margin: 0;
      }
      h2 {
        font-size: 1.2em;
        padding: 15px 0;
        margin: 0;
      }
      h3 {
        font-size: 1.1em;
        padding: 10px 0;
        margin: 0;
      }

      .info {
        font-style: italic;
        font-size: 0.8em;
      }

      .required {
        color: red;
      }

      .link-container, .invert-link-container {
    padding: 5px;
}


.mini {
    width: 15px;
}


.link-container:hover {
    background-color:#eee;
    border-radius: 10px;
}

      .nav-pills .tab-title .nav-link:not(.active) {
        background-color: #eee !important;
        border: 1px solid #ddd;
        border-radius: 0px;
        color: #000000;
        font-weight: normal;
      }

      .nav-pills .tab-title .nav-link {
        background-color: var(--color-main) !important;
        color: #fff;
        text-decoration: none;
        font-weight: normal;
        border-radius: 0px;
        border: 1px solid var(--color-main);
      }

      .page-item .page-link {
        color: #2c3e50;
      }

      .page-item .page-link:hover {
        color: #2c3e50;
      }
      .page-item.active .page-link {
        color: #fff !important;
        background: var(--color-main) !important;
        border: 0px solid var(--color-main);
      }

      .page-item.active {
        color: #fff !important;
        background: var(--color-main) !important;
        border: 1px solid var(--color-main);
      }

      .logo {
        width: 100%;
        margin-top: 50px;
        border-top: 1px solid var(--color-main);
        border-bottom: 1px solid var(--color-main);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 50px;
      }
      .logo img {
        width: 90%
      }

      .separator h2 {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 1em;
        }

        .separator h2::before,
        .separator h2::after {
          content: "";
          display: block;
          flex-grow: 1;
          height: 1px;
          background: #ccc;
        }

        .separator h2 span {
          padding: 0 2em;
        }
        .separator {
        margin-bottom: 20px;
        }

    }


.beta-banner {
  background-color: #facc15;
  color: #1f2937;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

  
.beta-banner a {
  color: #ffffff !important;
  text-decoration: underline;
}

.with-beta-banner {
  padding-top: 80px; /* ajustable selon la hauteur réelle */
}

.survey-banner {
  background-color: #FFA500;
  color: #1f2937;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  position: fixed;
  top: 40px;
  width: 100%;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
   animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
.survey-banner a {
  color: #ffffff !important;
  text-decoration: underline;
}

.with-survey-banner {
  padding-top: 40px; /* ajustable selon la hauteur réelle */
}

</style>
